export default "__VITE_ASSET__CHQRgWH9__"